import ComicCard from '@/components/base/ComicCard';
import { getNewComics } from '@/mocks/comics';
import { Link } from 'react-router-dom';

const LatestUpdates = () => {
  const newComics = getNewComics();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新上架
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              新鲜出炉 · 不容错过的新作韩国漫画
            </p>
          </div>
          <Link
            to="/category/fantasy"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer no-underline"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {newComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="normal" />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/fantasy"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer no-underline"
          >
            查看全部新作
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestUpdates;